import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const FullWidthContainerWrapper = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  padding: ${props => props.padding};
  height: 100%;
  overflow: hidden;
  img {
    height: 100%;

    width: 100%;
    max-height: 100vh;
  }
  .imageWrapper {
    height: 100%;
  }
`;

const FullWidthContainer = ({ children, padding, ...props }) => (
  <FullWidthContainerWrapper padding={padding} {...props}>
    <div className="row no-gutters h-100">{children}</div>
  </FullWidthContainerWrapper>
);

FullWidthContainer.propTypes = {
  padding: PropTypes.string
};

FullWidthContainer.defaultProps = {
  padding: "0px"
};

export { FullWidthContainer };
